// extracted by mini-css-extract-plugin
module.exports = {"root":"ComboboxItem_root__HZvOt","highlighted":"ComboboxItem_highlighted__2bD5J","selected":"ComboboxItem_selected__11qgn"};